<template>
  <div :style="countImgHeight">
    <el-carousel :height="imgHeight">
      <el-image
        v-if="swiperImg"
        ref="imgHeight"
        :src="swiperImg"
        fit="fill"
        @load="loadedImg"
      ></el-image>
      <el-carousel-item v-for="item in 3" :key="item" v-else>
        <el-image
          ref="imgHeight"
          :src="require(`./../../../public/images/banner/banner_0${item}.png`)"
          fit="fill"
          @load="loadedImg"
        ></el-image>
      </el-carousel-item>
    </el-carousel>
  </div>
</template>

<script>
export default {
  name: "c-banner",
  data() {
    return {
      swiperImg: "",
      imgHeight: "440px"
    };
  },
  computed: {
    countImgHeight() {
      return {
        height: this.imgHeight
      };
    }
  },
  mounted() {
    this.swiperImg = myconfig.swiperImg;
    window.onresize = () => {
      this.imgHeight = this.$refs.imgHeight[0].$el.clientHeight + "px";
      // this.countImgHeight()
    };
    // this.countImgHeight()
  },
  methods: {
    loadedImg() {
      this.imgHeight = this.$refs.imgHeight[0].$el.clientHeight + "px";
    }
  }
};
</script>

<style lang="scss">
.el-carousel ul li .el-carousel__button {
  width: 3.375rem;
  height: 0.25rem;
  background: #ff7c25;
  border-radius: 0.09375rem;
}
</style>
